module.exports = __webpack_public_path__ + "images/icons/icon-warranty-14fe44cc.svg";